import {
    Bot,
    CloudOff,
    Coffee,
    CookingPot,
    Home,
    MessageSquare,
    Speaker,
    Wifi,
} from "lucide-react";

const BELLY_ICONS = [
    { Icon: Coffee, label: "COFFEE", hot: true },
    { Icon: Bot, label: "AGENT" },
    { Icon: Wifi, label: "LOCAL NET" },
    { Icon: Speaker, label: "AUDIO" },
    { Icon: CookingPot, label: "KITCHEN" },
    { Icon: MessageSquare, label: "CHAT" },
    { Icon: CloudOff, label: "NO CLOUD" },
    { Icon: Home, label: "HOME ASSIST" },
];

export default function FaceScreenDemo() {
    return (
        <div
            data-testid="face-screen-demo"
            className="p-5 rounded-lg bg-white border border-subtle"
        >
            <div className="font-mono text-[10px] text-slate-500 flex items-center justify-between mb-4">
                <span className="text-cyan-600">HEAD UNIT // UI PREVIEW</span>
                <span>FACE FEED: LIVE // BLINK INTERVAL: ORGANIC</span>
            </div>

            <div className="grid grid-cols-2 gap-4">
                {/* Face screen — the real KindBot face, live */}
                <div className="rounded-lg bg-[#111418] p-2 shadow-inner">
                    <div className="rounded-md overflow-hidden aspect-square bg-white">
                        <iframe
                            src="https://kindbotface.conraddangerfield.com/"
                            title="KindBot face — live animation"
                            data-testid="kindbot-face-frame"
                            className="h-full w-full border-0"
                            loading="lazy"
                        />
                    </div>
                    <div className="mt-2 text-center font-mono text-[9px] text-slate-500 tracking-widest">
                        5&rdquo; FACE DISPLAY // LIVE FACE
                    </div>
                </div>

                {/* Belly screen */}
                <div className="rounded-lg bg-[#111418] p-2 shadow-inner flex flex-col">
                    <div
                        data-testid="belly-icon-grid"
                        className="rounded-md bg-[#1a1e24] flex-1 min-h-[180px] p-2 grid grid-cols-4 grid-rows-2 gap-1.5"
                    >
                        {BELLY_ICONS.map(({ Icon, label, hot }) => (
                            <div
                                key={label}
                                title={label}
                                className={`rounded flex items-center justify-center ${
                                    hot
                                        ? "bg-amber-500/15 text-amber-400 animate-status"
                                        : "bg-white/5 text-slate-300"
                                }`}
                            >
                                <Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4" strokeWidth={1.75} />
                            </div>
                        ))}
                    </div>
                    <div className="mt-2 text-center font-mono text-[9px] text-slate-500 tracking-widest">
                        10&rdquo; BELLY TOUCHSCREEN // COFFEE SHORTCUT: PRIORITISED
                    </div>
                </div>
            </div>
        </div>
    );
}
